/* eslint-disable @typescript-eslint/naming-convention */
export enum FspUserCulture {
  Dutch = 'nl-NL',
  EnglishAustralia = 'en-AU',
  EnglishBritish = 'en-GB',
  EnglishCanada = 'en-CA',
  EnglishUS = 'en-US',
  French = 'fr-FR',
}
